var React = require('react');

function ChevronIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.613 33.49c-.817.803-.817 2.107 0 2.91.82.8 2.152.8 2.973 0l16.801-16.445c.817-.803.817-2.107 0-2.91L3.586.6C2.766-.2 1.433-.2.613.6c-.817.803-.817 2.107 0 2.91L15.93 18.5.613 33.49z"}));
}

ChevronIcon.defaultProps = {"viewBox":"0 0 21 37"};

module.exports = ChevronIcon;

ChevronIcon.default = ChevronIcon;
